import { useEffect } from "react";

interface DocumentMeta {
  title: string;
  description?: string;
  keywords?: string;
}

function setMetaByName(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setMetaByProperty(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useDocumentMeta({ title, description, keywords }: DocumentMeta) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMetaByName("description", description);
      setMetaByProperty("og:description", description);
    }
    if (keywords) {
      setMetaByName("keywords", keywords);
    }
    setMetaByProperty("og:title", title);
  }, [title, description, keywords]);
}